import { PayIcon } from "@/components/Icons/PayIcon";
import { useUserStore } from "@/store/user";
import { BalanceType } from "@/types/user";
import { toLocaleString } from "@/utils/number";
import { cn } from "@/utils/styles";
import { useEffect, useMemo } from "react";
import { IoCoin } from "../IoCoin/IoCoin";

type UserBalanceType = {
  type: BalanceType;
  onFetchBalance?: (balance: number) => void;
  className?: string;
};

export const UserBalance = ({ type, className = "", onFetchBalance }: UserBalanceType) => {
  const balances = useUserStore((store) => store.balances);
  const fetchBalances = useUserStore((store) => store.fetchBalances);
  const balance = useMemo(() => {
    const newBalance = balances?.[type];
    return typeof newBalance === "number" ? toLocaleString(newBalance, 2) : 0;
  }, [balances, type]);

  const getBalanceText = () => {
    if (type === BalanceType.CLOUD) {
      return (
        <>
          <PayIcon className="h-[8px]" />
          <span className="label-small text-cyan">{balance}</span>
        </>
      );
    }
    if (type === BalanceType.CREDITS) {
      return <>$ {balance}</>;
    }

    return (
      <>
        <IoCoin />
        <span className="label-small text-blue-light-300">{balance}</span>
      </>
    );
  };

  useEffect(() => {
    (async () => {
      await fetchBalances();
    })();
  }, [fetchBalances, onFetchBalance]);

  useEffect(() => {
    if (!balances) {
      return;
    }
    onFetchBalance?.(balances?.[type] as number);
  }, [type, balances, onFetchBalance]);

  return (
    <div className={cn("flex flex-row items-center gap-2", className)}>{getBalanceText()}</div>
  );
};

<span className="text-base font-medium text-foreground">$ 2,350</span>;

// $IO <span className="text-gray">14,480.000</span> $SOL{" "}
// <span className="text-gray">501.010</span> $USDC{" "}
// <span className="text-gray">5,114.01</span>
